import { useSelector } from "react-redux";
import { ExtractFnReturnType, QueryConfig } from "../../../lib/react-query";
import { getClaimRelatedPeopleAffectedPeople } from "../api/ClaimAPI";
import { RootState } from "../../../redux/store";
import { PaginationFilterDto } from "../../../types/Pagination";
import { useQuery } from "@tanstack/react-query";

type QueryFnType = typeof getClaimRelatedPeopleAffectedPeople;

type UseGetClaimsForAffectedPerson = {
    config?: QueryConfig<QueryFnType>;
};

export const useGetClaimsForAffectedPerson = ({ config }: UseGetClaimsForAffectedPerson = {}) => {
    const selectedFilters = useSelector((state: RootState) => state.filters.claimsForPersonByAffectedPeople.selectedFilters);
    const pagination = useSelector((state: RootState) => state.historical.claimsForPersonByAffectedPeople);
    const filterByOnlyActiveRecords = useSelector((state: RootState) => state.filters.claimsForPersonByAffectedPeople.filterByOnlyActiveRecords);

    const paginationFilters: PaginationFilterDto =
    {
        pageNumber: pagination.currentPage,
        pageSize: pagination.itemsPerPage,
        search: pagination.searchText,
        filterByOnlyActiveRecords: filterByOnlyActiveRecords,
        filters: selectedFilters,
        selectedOrganizationalStructureIds: []
    };

    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        retry: false,
        queryKey: ['getClaimRelatedPeopleAffectedPeople', selectedFilters, pagination, filterByOnlyActiveRecords],
        enabled: selectedFilters?.some(
            x => x.values && x.values.some(v => v.trim() !== "")
        ),
        queryFn: () => getClaimRelatedPeopleAffectedPeople(paginationFilters),
    });
}
